import React, { useEffect, useState, useRef } from "react";
import SettingTreshold from "../molecules/popup/SettingTreshold";
import { useParams } from "react-router-dom";
import { MQTTI } from "../../helper/mqttClient";
import { fetchApi } from "../../helper/api";
import {
  UnpackData,
  UnpackLabel,
  SensorProps,
  ToCamelCase,
} from "../../helper/functionSensor";
import { lightGreen, blue, purple } from "@mui/material/colors";

import { Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js";
import "chartjs-adapter-moment";
import ChartStreaming from "chartjs-plugin-streaming";
import ChartAnnotation from "chartjs-plugin-annotation";
// import DownloadSensor from '../molecules/popup/DownloadSensor';
// import FFTGraph from './FftGraph';
import ChartMusi from "./ChartMusi";
import { PowerDistribution } from "./PowerDistributrion";

ChartJS.register(ChartStreaming, ChartAnnotation);

const RealTimeGraph = React.memo(({ sensor, PG }) => {
  let divRef = useRef({});
  const optGraph = {
    scales: {
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value) {
            return value.toFixed(2) + SensorProps[sensor.group].satuan;
          },
        },
        suggestedMax: SensorProps[sensor.group].max,
        suggestedMin: SensorProps[sensor.group].min,
        stepSize: SensorProps[sensor.group].step,
      },
      x: {
        type: "realtime",
        time: {
          unit: "second",
        },
        realtime: {
          duration: 10000,
          frameRate: 30,
          ttl: 12000,
          delay: 1200,
        },
      },
    },
    elements: {
      point: {
        radius: 0,
        hoverRadius: 0,
        hitRadius: 0,
      },
      line: {
        tension: 0,
      },
    },
  };
  const getOption = (indexGraph) => {
    console.log("PG", PG, indexGraph);
    const statement = () => {
      const splitIndex =
        sensor.group === "LVDT" || sensor.group === "Strain" ? 0 : 1;
      if (sensor.group === "Strain") {
        return "microstrain";
      } else if (sensor.group === "LVDT") {
        return "mm";
      } else {
        return PG[indexGraph].name.split(" ")[splitIndex].toLowerCase();
      }
    };
    const warningMinIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Warning Min"
    );
    const warningMinArray = sensor.sensorProps[warningMinIndex]?.values ?? [];

    const warningMinAxis =
      warningMinArray[
        warningMinArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ]?.value ?? 0;

    ///
    const warningMaxIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Warning Max"
    );
    const warningMaxArray = sensor.sensorProps[warningMaxIndex]?.values ?? [];
    const warningMaxAxis =
      warningMaxArray[
        warningMaxArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ].value ?? 0;

    ///
    const dangerMinIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Danger Min"
    );
    const dangerMinArray = sensor.sensorProps[dangerMinIndex]?.values ?? [];
    const dangerMinAxis =
      dangerMinArray[
        dangerMinArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ].value ?? 0;

    ///
    const dangerMaxIndex = sensor.sensorProps.findIndex(
      (find) => find.type === "Threshold Danger Max"
    );
    const dangerMaxArray = sensor.sensorProps[dangerMaxIndex]?.values ?? [];
    const dangerMaxAxis =
      dangerMaxArray[
        dangerMaxArray.findIndex(
          (find) => find.axis.toLowerCase() === statement()
        )
      ].value ?? 0;
    // const split = dataPG.split(" ")
    // // const typeSensor =  split[0]
    // const axis = split[1]
    // const tempDataTh = {}
    // sensor.sensorProps.forEach((prop) => {
    //   const typeProp = ToCamelCase(prop.type)
    //   if (!typeProp.includes("gain") && !typeProp.includes("offset")) {
    //     prop.values.forEach((value) => {
    //       if (value.axis == ToCamelCase(axis)) {
    //         // tempDataTh.push(value.value)
    //         Object.assign(tempDataTh, { [typeProp]: value.value })
    //       }
    //     })
    //   }
    // });
    let optionTreshold = {
      annotation: {
        annotations: {
          dangerMax: {
            type: "line",
            value: () => dangerMaxAxis,
            yMin: () => dangerMaxAxis,
            yMax: () => dangerMaxAxis,
            borderColor: "#d9534f",
            borderWidth: 2,
            label: {
              backgroundColor: "#d9534f67",
              backgroundShadowColor: "transparent",
              content: () => `Danger Max${dangerMaxAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
          dangerMin: {
            type: "line",
            value: () => dangerMinAxis,
            yMin: () => dangerMinAxis,
            yMax: () => dangerMinAxis,
            borderColor: "#d9534f",
            borderWidth: 2,
            label: {
              backgroundColor: "#d9534f67",
              backgroundShadowColor: "transparent",
              content: () => `Danger Min${dangerMinAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
          warningMax: {
            type: "line",
            value: () => warningMaxAxis,
            yMin: () => warningMaxAxis,
            yMax: () => warningMaxAxis,
            borderColor: "#fd9d0d",
            borderWidth: 2,
            label: {
              backgroundColor: "#fd9d0d67",
              backgroundShadowColor: "transparent",
              content: () => `Warning Max${warningMaxAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
          warningMin: {
            type: "line",
            value: () => warningMinAxis,
            yMin: () => warningMinAxis,
            yMax: () => warningMinAxis,
            borderColor: "#fd9d0d",
            borderWidth: 2,
            label: {
              backgroundColor: "#fd9d0d67",
              backgroundShadowColor: "transparent",
              content: () => `Warning Min${warningMinAxis}`,
              enabled: true,
              xAdjust: +20,
            },
          },
        },
      },
    };
    return optionTreshold;
    // return {}
  };

  const createGraph = () => {
    let graph = PG.map(
      (graph, index) =>
        graph.show && (
          <div
            key={graph.name}
            className="bg-white rounded-banget shadow p-2 mb-4"
          >
            <Line
              ref={(ref) => (divRef.current[graph.name] = ref)}
              options={{
                ...optGraph,
                ...getOption(index),
              }}
              data={graph.data}
            />
          </div>
        )
    );
    return graph;
  };
  useEffect(() => {
    if (sensor && divRef.current !== null) {
      const instance = MQTTI().subscribe(
        `dataStream/${sensor.idIpc}/${sensor.idSensor}`
      );
      instance.on("message", (topic, message) => {
        // const payload = { topic, message: message.toString() };
        const raw = message.toString().split(",");
        const ts = raw[0];
        const dataToUnpack = raw[1];
        const dataSensor = UnpackData(sensor.group, dataToUnpack);
        const labelData = UnpackLabel(
          +ts,
          dataToUnpack.length / (6 * Object.keys(PG).length),
          sensor.sampleRate
        );

        // plot to grafik
        if (dataSensor != undefined) {
          PG.forEach((graph) => {
            if (divRef.current[graph.name]) {
              divRef.current[graph.name].data.datasets[0].label = graph.name;
              divRef.current[graph.name].data.labels.push(...labelData);
              divRef.current[graph.name].data.datasets[0].data.push(
                ...dataSensor[graph.name]
              );
              // divRef.current[graph.name].update("quiet");
            }
          });
        }
      });
      return () => {
        instance.end();
      };
    }
  }, []);

  return <div className="px-2">{createGraph()}</div>;
});
const SwitchGraph = React.memo(({ sensor, ipc }) => {
  switch (sensor.group) {
    case "Accelerometer":
      const accX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
            // pointRadius: 1,
            // pointHoverRadius: 5,
            // pointHitRadius: 10,
          },
        ],
      };
      const accY = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: blue["700"],
            borderColor: blue["700"],
            borderWidth: 1.5,
            hidden: false,
            // pointRadius: 1,
            // pointHoverRadius: 5,
            // pointHitRadius: 10,
          },
        ],
      };
      const accZ = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: purple["600"],
            borderColor: purple["600"],
            borderWidth: 1.5,
            hidden: false,
            // pointRadius: 1,
            // pointHoverRadius: 5,
            // pointHitRadius: 10,
          },
        ],
      };
      const accPg = [
        {
          name: `${sensor.group} X`,
          data: accX,
          show: true,
        },
        {
          name: `${sensor.group} Y`,
          data: accY,
          show: true,
        },
        {
          name: `${sensor.group} Z`,
          data: accZ,
          show: true,
        },
      ];
      return <RealTimeGraph sensor={sensor} PG={accPg} />;
    // return Acc;
    case "Strain":
      const strX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const strPg = [
        {
          name: `${sensor.group}`,
          data: strX,
          show: true,
        },
      ];
      return <RealTimeGraph sensor={sensor} PG={strPg} />;
    // return Strain;
    case "Gyroscope":
      const gyrX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: blue["700"],
            borderColor: blue["700"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const gyrY = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: blue["700"],
            borderColor: blue["700"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const gyrZ = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: purple["600"],
            borderColor: purple["600"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const gyrPg = [
        {
          name: `${sensor.group} X`,
          data: gyrX,
          show: false,
        },
        {
          name: `${sensor.group} Pitch Y`,
          data: gyrY,
          show: true,
        },
        {
          name: `${sensor.group} Roll Z`,
          data: gyrZ,
          show: true,
        },
      ];

      return <RealTimeGraph sensor={sensor} PG={gyrPg} />;
    // return Gyro;
    case "LVDT":
      const lvdtX = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const lvdtPg = [
        {
          name: `LVDT`,
          data: lvdtX,
          show: true,
        },
      ];
      return <RealTimeGraph sensor={sensor} PG={lvdtPg} />;
    // return LVDT
    case "Temperature":
      const temp = {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
            fill: false,
            backgroundColor: lightGreen["800"],
            borderColor: lightGreen["800"],
            borderWidth: 1.5,
            hidden: false,
          },
        ],
      };
      const TempPg = {
        Temperature: {
          ref: null,
          data: temp,
        },
      };
      break;
    // return <RealTimeGraph sensor={sensor} PG={TempPg} />
    // return LVDT

    case "Power Distribution":
      return (
        <PowerDistribution topic={`dataStream/${ipc}/${sensor.idSensor}`} />
      );

    default:
      return <>Sensor is not detected...</>;
    // return Acc;
  }
});
const ChartMonitorMobile = () => {
  const params = useParams();
  const [sensor, setSensor] = useState();
  const [isLoad, setIsLoad] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    var req = await fetchApi(`api/Rtu/details-mobile/${params.id}`, "GET");
    var res = await req.json();
    if (req.status !== 404) {
      setSensor(res.data);
    }
    setIsLoad(false);
  };
  const updateTreshold = () => {
    getData();
  };

  return (
    <>
      {isLoad && <>Loading ...</>}
      {sensor ? (
        !sensor.idIpc.includes("IPCC") ? (
          <SwitchGraph sensor={sensor} ipc={sensor.idIpc} />
        ) : (
          <ChartMusi sensor={params.id} ipc={sensor.idIpc} />
        )
      ) : (
        <>Sensor tidak tersedia</>
      )}
    </>
  );
};
export default ChartMonitorMobile;
